import { applicationStore } from '../store/applicationStore';
import { gameMainDrawer } from '../game/drawers/gameMainDrawer';
import { PixiBase } from '../core/pixi/PixiBase';
import { PopupTypes } from '../constants/popupTypes';
import { spinBarStore } from '../store/spinBarStore';

export const handleTournamentIcon = () => {
  applicationStore.tournamentIconsInfo?.forEach((item) => {
    if (item.type === 'Tournament') {
      PixiBase.setupButtonMode(gameMainDrawer.slotBoard.tournamentIcon, {
        interactive: true,
        buttonMode: true,
      });
      gameMainDrawer.slotBoard.tournamentIcon.type = item.type;
      gameMainDrawer.slotBoard.tournamentIcon.visible = true;
    }
  });
  PixiBase.registerClick(gameMainDrawer.slotBoard.tournamentIcon, (event) => {
    if (event.type) {
      window.parent.postMessage(
        { name: PopupTypes.onOpenerIconClick, type: event.target.type },
        '*'
      );
    }
  });
};
